<template>
    <div class="sideformCtn" v-if="open" @click="onClickOutside">
        <v-runtime-template v-if="template" :template="template" />
        <div v-else class="sideform"><div class="sideformLoader"></div></div>
    </div>
</template>



<script>
import VRuntimeTemplate from 'v-runtime-template'
import MultiSelect from './MultiSelect.vue'
import PosMultiSelect from './PosMultiSelect.vue'
import QuantityCounter from './QuantityCounter.vue'
import FileInput from './FileInput.vue'

export default {


    /* Settings
    --------------------------------------------------------- */

    name: 'SideForm',

    components: {
        VRuntimeTemplate,
        MultiSelect,
        PosMultiSelect,
        QuantityCounter,
        FileInput,
    },

    props: {
    },

    data() {
        return {
            template: '',
            open: false,
        }
    },




    /* Life Cycle
    --------------------------------------------------------- */

    created() {
        // this.$root.$on('sideform.open', (e) => {
        //     this.openSideForm()
        //     const url = e.currentTarget.getAttribute('href')
        //     this.loadHtml(url)
        // })
    },


    mounted() {
        //
    },

    updated() {
        this.$emit('sideform-content-updated')
    },




    /* Data Handling
    --------------------------------------------------------- */

    computed: {
    },


    watch: {
        //
    },




    /* Methods
    --------------------------------------------------------- */

    methods: {
        loadHtml(url) {
            this.$nextTick(() => {
                this.setLoading(true)
            })

            const h = new Headers()
            h.append('X-Requested-With', 'XMLHttpRequest')
            h.append('Cache-Control', 'no-cache, no-store, must-revalidate')
            h.append('Pragma', 'no-cache')
            h.append('Expires', '0')

            const fetchOptions = {
                headers     : h,
                credentials : 'same-origin',
            }

            fetch(url, fetchOptions)
                .then((r) => {
                    if (r.status !== 200 && r.status !== 422) {
                        throw Error(r)
                    }

                    return r.text()
                })
                .then((html) => {
                    this.template = html
                    this.setLoading(false)
                    this.$nextTick(() => {
                        APP.Layout.initComps()
                        this.$emit('sideform-content-loaded')
                    })
                })
                .catch((error) => {
                    window.location.reload()
                })
        },


        onClickOutside(e) {
            if (!e.target.closest('.sideform')) {
                this.close()
            }
        },


        openSideForm() {
            this.open = true
        },


        close() {
            this.open = false
            this.template = ''
        },

        setLoading(state) {
            if (this.$el.querySelector) {
                this.$el.classList.toggle('is-loading', state)
            }
        },
    },


}

</script>
